import React from 'react';
import './style/FeaturesList.css'; // Предполагается, что стили будут определены в этом CSS файле

const features = [
  {
    icon: './store_pictures/Onlyqualityproducts.bmp', // Относительный путь к изображению
    title: 'Только качественные продукты',
  },
  {
    icon: './store_pictures/Favorablepricesforallcategories.bmp',
    title: 'Выгодные цены на все категории',
  },
  {
    icon: './store_pictures/Activesupportteam.bmp',
    title: 'Активная служба поддержки',
  },
  {
    icon: './store_pictures/Fastdeliverytoyourdoor.bmp',
    title: 'Быстрая доставка до двери',
  },
  {
    icon: './store_pictures/Convenientpaymentwhenordering.bmp',
    title: 'Удобная оплата при заказе',
  }
];

const Feature = ({ icon, title }) => (
  <div className="feature">
    <img src={require(`${icon}`)} alt={title} className="feature-icon" />
    <div className="feature-title">{title}</div>
  </div>
);


const FeaturesList = () => (
  <div className="features-container">
    {features.map((feature, index) => (
      <Feature key={index} icon={feature.icon} title={feature.title} />
    ))}
  </div>
);

export default FeaturesList;

